import { Typography, Breadcrumb } from 'antd';
import { Head, router } from '@inertiajs/react';

import AdminLayout from '../../../components/layouts/AdminLayout';
import EventForm from './components/EventForm';
import { EventOwner } from '../event_owners/index.page';
import { Event, Category } from '@/types/events';

const { Title } = Typography;

interface EditEventProps {
  eventJson: Event;
  categories: Category[];
  event_owners: EventOwner[];
  errors?: Record<string, string[]>;
}

export default function EditEvent({ eventJson , categories, event_owners, errors }: EditEventProps) {
  const event = eventJson;
  return (
    <AdminLayout>
      <Head title="Edit Event" />
      <div className="w-full bg-white">
        {/* Header section */}
        <div className="bg-white flex justify-between items-center px-6 py-4 border-b border-gray-200">
          <div>
            <Breadcrumb
              items={[
                { title: <a onClick={() => router.visit('/admin/events')}>List of Events</a> },
                { title: 'Edit Event' },
              ]}
              className="mb-2"
            />
            <Title level={4} className="!mb-0">Edit Event: {eventJson.name}</Title>
          </div>
        </div>

        {/* Form section */}
        <div className="pt-6">
          {/* Display validation errors if they exist */}
          {errors && Object.keys(errors).length > 0 && (
            <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded">
              <h3 className="text-red-800 font-medium mb-2">Please fix the following errors:</h3>
              <ul className="list-disc list-inside text-red-600">
                {Object.entries(errors).map(([field, messages]) => (
                  messages.map((message, idx) => (
                    <li key={`${field}-${idx}`}>{field}: {message}</li>
                  ))
                ))}
              </ul>
            </div>
          )}
          <EventForm
            initialValues={event}
            categories={categories || []}
            eventOwners={event_owners || []}
            action={`/admin/events/${event.id}`}
            method="patch"
          />
        </div>
      </div>
    </AdminLayout>
  );
}
